import { NotificationsTranslations } from '../en-US/notifications.translations';

export const notificationsTranslations: NotificationsTranslations = {
  title: 'Notificaciones',
  pageTitle: 'Notificaciones',
  pageDescription: 'Ver y gestionar tus notificaciones',
  settingsTitle: 'Configuración de notificaciones',
  settingsPageTitle: 'Configuración de notificaciones',
  settingsPageDescription: 'Gestionar tus preferencias de notificaciones',
  settings: 'Configuración',
  markAsRead: 'Marcar como leído',
  markAllAsRead: 'Marcar todo como leído',
  delete: 'Eliminar',
  more: 'más',
  noNotifications: 'Sin notificaciones',
  emptyDescription: 'Aún no tienes notificaciones',
  errorLoading: 'Error al cargar las notificaciones',
  errorLoadingSettings: 'Error al cargar la configuración de notificaciones',
  tryAgain: 'Por favor, inténtalo de nuevo más tarde',
  enableNotifications: 'Activar notificaciones',
  enablePromptMessage: 'Mantente al día con las últimas reseñas, me gusta y seguidores activando las notificaciones.',
  remindLater: 'Recordar más tarde',
  enable: 'Activar',
  stayUpdated: 'Mantente actualizado',
  enableDescription: 'Activa las notificaciones para mantenerte informado sobre nuevas reseñas, me gusta y seguidores.',
  pushNotifications: 'Notificaciones push',
  pushDescription: 'Recibe notificaciones en tu dispositivo',
  emailNotifications: 'Notificaciones por correo',
  emailDescription: 'Recibe notificaciones por correo electrónico',
  enableAllNotifications: 'Activar todas las notificaciones',
  masterToggleDescription: 'Activar/desactivar todas las notificaciones',
  notificationTypes: 'Tipos de notificaciones',
  types: {
    reviewLiked: 'Reseña gustada',
    reviewLikedDescription: 'Recibe una notificación cuando a alguien le gusta tu reseña',
    newPlaceReviews: 'Nuevas reseñas de lugares',
    newPlaceReviewsDescription: 'Recibe una notificación cuando se reseña un nuevo lugar',
    newFoodReviews: 'Nuevas reseñas de comida',
    newFoodReviewsDescription: 'Recibe una notificación cuando se reseña una nueva comida',
    newReviewCreated: 'Nueva reseña creada',
    newReviewCreatedDescription: 'Recibe una notificación cuando se crea una nueva reseña',
    userFollowed: 'Usuario seguido',
    userFollowedDescription: 'Recibe una notificación cuando un usuario te sigue',
  },
}; 

export default notificationsTranslations;
